import { AppState } from 'state/types';

export const getBottomPinnedLegendEnabled = (state: AppState): boolean =>
  (state as any).bottomPinnedLegend;
